export const actionButtonsContent = {
  popupTitle: 'How it looks in Slack',
  title: 'Get Help',
  titleTooltip: 'Heading',
  description: 'Need further assistance? Try these options:',
  descriptionTooltip: 'Description',
  actionButtons: [
    { text: 'Report Issue', tooltip: 'Button name' },
    { text: 'Request Service', tooltip: 'Button name' },
  ],
};
